import classNames from 'classnames';
import { ILocalizationContext, LocalizationContext } from './localizationState/localizationContext';
import EditMode from './components/EditMode/EditMode';
import ViewMode from './components/ViewMode/ViewMode';
import React, { useContext } from 'react';
import style from './LocalizationForm.module.scss';

interface ILocalizationForm {
	isVisible: boolean;
}

const LocalizationForm: React.FC<ILocalizationForm> = ({ isVisible }) => {
	const { mode } = useContext<ILocalizationContext>(LocalizationContext);

	const containerClasses = classNames(style.container, { [style.visible]: isVisible });
	return (
		<div className={containerClasses} data-test="LocalizationForm">
			{mode === 'edit' && <EditMode />}
			{mode === 'view' && <ViewMode />}
		</div>
	);
};

export default LocalizationForm;
